import {
  MarketingChannel,
  SuppressionFormData,
  SuppressionReason,
  CreateFromSuppressionRequest
} from './types';

export const allMarketingChannels = Object.values(MarketingChannel).filter(
  (key) => key !== MarketingChannel.AllMarketing
);

const convertMarketingChannels = (marketingChannels: string[]) => {
  const channels = new Set(marketingChannels ?? []);

  const selectedAll = allMarketingChannels.every((c) => channels.has(c));

  if (selectedAll) {
    return [Number(MarketingChannel.AllMarketing)];
  }

  return Array.from(channels).map(Number);
};

export const buildSuppressionSubmissionPayload = (
  formData: SuppressionFormData,
  campaignId: string | null,
  country: string
): CreateFromSuppressionRequest => {
  return {
    campaignId: Number(campaignId || 0),
    surname: formData.surname,
    postCode: formData.postcode,
    vehicleRegistration: formData.vehicleRegistration,
    vehicleVIN: formData.vin,
    country,
    goneAwaysReason: Number(
      formData.suppressionReason || SuppressionReason.None
    ),
    unsubscribeOptions: convertMarketingChannels(formData.marketingChannels),
    firstName: formData.firstName,
    emailAddress: formData.email,
    phoneNumber: formData.telephone,
    addressLine1: formData.addressLine1
  };
};
